const translations = {
  en: {
    login: 'Login',
    username: 'Username',
    password: 'Password',
    enterUsername: 'Enter your username',
    enterPassword: 'Enter your password',
    invalidCredentials: 'Invalid login credentials',
    dashboard: 'Dashboard',
    userInfo: 'Intelligent oil mist filter',
    welcomeUser: 'Welcome, User!',
    devices: 'Devices',
    language: 'Language',
    logout: 'Logout',
    loadingDevices: 'Loading devices...',
    loadingData: 'Loading data...',
    testText: 'This is a test tile.',
    cleaned: 'Cleaned',
    dirty: 'Dirty',
    filter_pressure: 'Filter pressure',
    filter_status: 'Filter status',
    no_proces: 'No process',
    process_recognition: 'Process recognition',
    process_unrecognized: 'Unrecognised process',
    nonr_proces: 'Unrecognised process',
    r_proces: 'Recognised process',
    cleaning: 'Cleaning',
    off: 'Disabled',
    cleaning_pressure: 'Cleaning pressure',
    filter_usage_history: 'Filter element usage over time',
    last: 'Last record',
    basicView: 'Basic view',
    advancedView: 'Advanced view',
    loading: 'Loading...',
    minutes: 'min',
    hours: 'h',
    days: 'days',
    timeUnitInfo: 'Displayed values are in minutes, hours or days depending on the amount.',
    regression: 'regression',
    threshold: 'Threshold for filter change',
    hepa_filter: 'Filter element usage',
    process_times: 'Process Times',
    device_statistics: 'Device Statistics',
    allTime: 'Total device uptime since filter change',
    fanTime: 'Fan runtime since filter change',
    lastReadStatus: 'Last read status',
    unknown: 'Unknown',
    noCommunicationSince: 'No communication for',
    hour: 'hour',
    day: 'day',
    no_proces_desc: 'During this state, no process is being carried out.',
    process_recognition_desc: 'A new process has started and is currently being recognised.',
    process_unrecognized_desc: 'The process has not been recognised.',
    nonr_proces_desc: 'The device is in the process of recognising the process or the process is unrecognised.',
    r_proces_desc: 'The device has detected and recognised the process.',
    cleaning_desc: 'The device is in cleaning mode of the processing chamber.',
    adminPanel: 'Admin panel',
    adminOnly: 'Admin access only',
    createUser: 'Create user',
    assignFilter: 'Assign filter',
    selectUser: 'Select user',
    selectFilter: 'Select filter',
    customFilterName: 'Custom filter name',
    userAssignments: 'User assignments',
    filtersOverview: 'Filters overview',
    hepaUsagePercent: 'Filter element usage',
    assignedUsers: 'Assigned users',
    assignedFilters: 'Assigned filters',
    save: 'Save',
    saveError: 'Save failed',
    rename: 'Rename',
    renameFilter: 'Rename filter',
    renameFilterPrompt: 'Enter a new filter name',
    renameSuccess: 'Filter name has been updated',
    filterNameRequired: 'Filter name is required',
    searchUsers: 'Search users...',
    searchDevices: 'Search devices...',
    searchAssignments: 'Search assignments...',
    searchFilters: 'Search filters by name or MAC...',
    minHepa: 'Min usage %',
    maxHepa: 'Max usage %',
    clearFilters: 'Clear filters',
    noResults: 'No results',
    usersList: 'Users',
    role: 'Role',
    status: 'Status',
    adminRole: 'Administrator',
    userRole: 'User',
    activeStatus: 'Active',
    inactiveStatus: 'Inactive',
    lastLogin: 'Last login',
    activateUser: 'Activate',
    deactivateUser: 'Deactivate',
    activateUserConfirm: 'Activate this user account?',
    deactivateUserConfirm: 'Deactivate this user account?',
    changePassword: 'Change password',
    newPasswordPrompt: 'Enter new password',
    confirmPasswordPrompt: 'Confirm new password',
    passwordMismatch: 'Passwords do not match',
    passwordChanged: 'Password has been changed',
    passwordRequired: 'Both password fields are required',
    kioskManagement: 'Kiosk management',
    kioskName: 'Kiosk name',
    kioskSlug: 'Kiosk slug',
    createKiosk: 'Create kiosk',
    kiosksList: 'Kiosks',
    generateActivationLink: 'Generate activation link',
    activationLinkGenerated: 'Activation link generated and copied to clipboard',
    latestActivationLink: 'Latest activation link',
    adminMainTab: 'Main panel',
    adminUsersTab: 'Users',
    adminFiltersTab: 'Filters',
    adminKioskTab: 'Kiosks',
    searchKiosks: 'Search kiosks...',
    edit: 'Edit',
    editKiosk: 'Edit kiosk',
    deactivateKiosk: 'Deactivate',
    activateKiosk: 'Activate',
    allowedIp: 'Allowed IP (optional)',
    cancel: 'Cancel',
    kioskFilterName: 'Kiosk filter name',
    leaflet: 'Leaflet',
    devicesAdmin: 'Devices catalog',
    serialNumber: 'Serial number',
    location: 'Location',
    globalFilterNamePrompt: 'Enter a global device name',
    serialNumberPrompt: 'Enter serial number',
    locationPrompt: 'Enter location',
    delete: 'Delete',
    deleteConfirm: 'Are you sure you want to delete this item?',
    hepaEvents: 'Filter element replacement events',
    addReplacementEvent: 'Add replacement',
    editReplacementEvent: 'Edit replacement event',
    replacementHour: 'Replacement hour',
    replacementHourPrompt: 'Enter replacement datetime (ISO)',
    replacementNote: 'Note',
    replacementNotePrompt: 'Enter note',
    replacementHourRequired: 'Replacement date and time are required',
    source: 'Source',
    daily_completed_processes: 'Today completed processes',
    completedProcesses: 'Completed processes',
    recognizedProcesses: 'Recognized processes',
    unrecognizedProcesses: 'Unrecognized processes',
    recognitionRate: 'Recognition rate',
    confidenceScore: 'Confidence score',
    hourUnit_one: 'hour',
    hourUnit_few: 'hours',
    hourUnit_many: 'hours',
    notificationSettings: 'Notification settings',
    notificationSettingsAdmin: 'User notification settings',
    notificationHistory: 'Notification history',
    notificationHistoryAdmin: 'Notification history',
    notificationsPerFilter: 'Notifications',
    contactEmail: 'Contact email',
    preferredLanguage: 'Preferred language',
    offlineThresholdMinutes: 'Offline threshold (min)',
    warningThresholdPercent: 'Warning threshold (%)',
    notifyOffline: 'Offline alert',
    notifyReconnected: 'Communication restored',
    notifyFilterWarning: 'Prepare for replacement',
    notifyFilterReplacement: 'Replace filter',
    notifyFilterReplacementReminder: 'Weekly reminder',
    recipient: 'Recipient',
    notificationType: 'Notification type',
    notificationDetails: 'Details',
    adminConfirmNotificationEdit: 'Confirm editing user notification settings.',
    notificationType_offline: 'No communication',
    notificationType_reconnected: 'Communication restored',
    notificationType_filter_warning: 'Filter warning',
    notificationType_filter_replacement: 'Filter replacement',
    notificationType_filter_replacement_reminder: 'Replacement reminder',
    notificationType_filter_replacement_event: 'Replacement table entry',
    notificationType_device_malfunction: 'Malfunction',
    notificationType_device_emergency: 'Anomaly',
    notificationStatus_pending: 'Pending',
    notificationStatus_sent: 'Sent',
    notificationStatus_skipped: 'Skipped',
    notificationStatus_failed: 'Failed',
    notificationSettingsLoadError: 'Notification settings could not be loaded.',
    confirmAction: 'Confirm',
    close: 'Close',
  },
  pl: {
    login: 'Zaloguj się',
    username: 'Nazwa użytkownika',
    password: 'Hasło',
    enterUsername: 'Wprowadź swoją nazwę użytkownika',
    enterPassword: 'Wprowadź swoje hasło',
    invalidCredentials: 'Nieprawidłowe dane logowania',
    dashboard: 'Panel główny',
    userInfo: 'Inteligentny filtr mgły olejowej',
    welcomeUser: 'Witaj, Użytkowniku!',
    devices: 'Urządzenia',
    language: 'Język',
    logout: 'Wyloguj',
    loadingDevices: 'Ładowanie urządzeń...',
    loadingData: 'Ładowanie danych...',
    testText: 'To jest kafelek testowy.',
    cleaned: 'Wyczyszczone',
    dirty: 'Zanieczyszczone',
    filter_pressure: 'Ciśnienie filtra',
    filter_status: 'Status filtra',
    no_proces: 'Brak procesu',
    process_recognition: 'Rozpoznawanie procesu',
    process_unrecognized: 'Nierozpoznany proces',
    nonr_proces: 'Nierozpoznany proces',
    r_proces: 'Rozpoznany proces',
    cleaning: 'Czyszczenie',
    off: 'Wyłączony',
    cleaning_pressure: 'Ciśnienie czyszczenia',
    filter_usage_history: 'Zużycie wkładów filtracyjnych w czasie',
    last: 'Ostatni odczyt',
    basicView: 'Widok podstawowy',
    advancedView: 'Widok zaawansowany',
    loading: 'Ładowanie...',
    minutes: 'min',
    hours: 'h',
    days: 'dni',
    timeUnitInfo: 'Wyświetlane wartości są w minutach, godzinach lub dniach w zależności od ilości.',
    regression: 'regresja',
    threshold: 'Próg wymiany wkładu filtrującego',
    hepa_filter: 'Zużycie wkładów filtracyjnych',
    process_times: 'Czasy procesów',
    device_statistics: 'Statystyki urządzenia',
    allTime: 'Całkowity czas pracy urządzenia od zmiany wkładu',
    fanTime: 'Czas pracy wentylatora od zmiany wkładu filtrującego',
    lastReadStatus: 'Ostatni odczytany stan',
    unknown: 'Nieznany',
    noCommunicationSince: 'Brak komunikacji od',
    hour: 'godziny',
    day: 'dnia',
    no_proces_desc: "W tym stanie żaden proces nie jest wykonywany.",
    process_recognition_desc: "Rozpoczął się nowy proces i trwa jego rozpoznawanie.",
    process_unrecognized_desc: "Proces nie został rozpoznany.",
    nonr_proces_desc: "Urządzenie jest w trakcie rozpoznawania procesu  lub proces nie został zidentyfikowany.",
    r_proces_desc: "Urządzenie wykryło i prawidłowo rozpoznało proces.",
    cleaning_desc: "Urządzenie znajduje się w trybie czyszczenia komory roboczej."
    ,
    adminPanel: 'Panel administratora',
    adminOnly: 'Dostęp tylko dla administratora',
    createUser: 'Utwórz użytkownika',
    assignFilter: 'Przypisz filtr',
    selectUser: 'Wybierz użytkownika',
    selectFilter: 'Wybierz filtr',
    customFilterName: 'Nazwa filtra dla użytkownika',
    userAssignments: 'Przypisania użytkowników',
    filtersOverview: 'Przegląd filtrów',
    hepaUsagePercent: 'Zużycie wkładów filtracyjnych',
    assignedUsers: 'Liczba przypisanych użytkowników',
    assignedFilters: 'Liczba przypisanych filtrów',
    save: 'Zapisz',
    saveError: 'Nie udało się zapisać',
    rename: 'Zmień nazwę',
    renameFilter: 'Zmień nazwę filtra',
    renameFilterPrompt: 'Podaj nową nazwę filtra',
    renameSuccess: 'Nazwa filtra została zapisana',
    filterNameRequired: 'Nazwa filtra jest wymagana',
    searchUsers: 'Szukaj użytkownika...',
    searchDevices: 'Szukaj urządzenia...',
    searchAssignments: 'Szukaj przypisania...',
    searchFilters: 'Szukaj po nazwie lub MAC...',
    minHepa: 'Min zużycie %',
    maxHepa: 'Max zużycie %',
    clearFilters: 'Wyczyść filtry',
    noResults: 'Brak wyników'
    ,
    usersList: 'Użytkownicy',
    role: 'Rola',
    status: 'Status',
    adminRole: 'Administrator',
    userRole: 'Użytkownik',
    activeStatus: 'Aktywny',
    inactiveStatus: 'Nieaktywny',
    lastLogin: 'Ostatnie logowanie',
    activateUser: 'Aktywuj',
    deactivateUser: 'Dezaktywuj',
    activateUserConfirm: 'Aktywować to konto użytkownika?',
    deactivateUserConfirm: 'Dezaktywować to konto użytkownika?',
    changePassword: 'Zmień hasło',
    newPasswordPrompt: 'Podaj nowe hasło',
    confirmPasswordPrompt: 'Potwierdź nowe hasło',
    passwordMismatch: 'Hasła nie są takie same',
    passwordChanged: 'Hasło zostało zmienione',
    passwordRequired: 'Oba pola hasła są wymagane'
    ,
    kioskManagement: 'Zarządzanie kioskami',
    kioskName: 'Nazwa kiosku',
    kioskSlug: 'Slug kiosku',
    createKiosk: 'Utwórz kiosk',
    kiosksList: 'Kioski',
    generateActivationLink: 'Generuj link aktywacyjny',
    activationLinkGenerated: 'Wygenerowano link aktywacyjny i skopiowano do schowka',
    latestActivationLink: 'Ostatni link aktywacyjny'
    ,
    adminMainTab: 'Panel główny',
    adminUsersTab: 'Użytkownicy',
    adminFiltersTab: 'Filtry',
    adminKioskTab: 'Kioski',
    searchKiosks: 'Szukaj kiosków...',
    edit: 'Edytuj',
    editKiosk: 'Edytuj kiosk',
    deactivateKiosk: 'Dezaktywuj',
    activateKiosk: 'Aktywuj',
    allowedIp: 'Dozwolone IP (opcjonalnie)',
    cancel: 'Anuluj',
    kioskFilterName: 'Nazwa filtra w kiosku'
    ,
    leaflet: 'Ulotka',
    devicesAdmin: 'Katalog urządzeń',
    serialNumber: 'Numer seryjny',
    location: 'Lokalizacja',
    globalFilterNamePrompt: 'Podaj globalną nazwę filtra',
    serialNumberPrompt: 'Podaj numer seryjny',
    locationPrompt: 'Podaj lokalizację'
    ,
    delete: 'Usuń',
    deleteConfirm: 'Czy na pewno chcesz usunąć ten element?'
    ,
    hepaEvents: 'Zdarzenia wymiany wkładów filtracyjnych',
    addReplacementEvent: 'Dodaj wymianę',
    editReplacementEvent: 'Edytuj zdarzenie wymiany',
    replacementHour: 'Godzina wymiany',
    replacementHourPrompt: 'Podaj datę i godzinę wymiany (ISO)',
    replacementNote: 'Notatka',
    replacementNotePrompt: 'Podaj notatkę',
    replacementHourRequired: 'Data i godzina wymiany są wymagane',
    source: 'Źródło'
    ,
    daily_completed_processes: 'Dzisiejsze zakończone procesy',
    completedProcesses: 'Zakończone procesy',
    recognizedProcesses: 'Rozpoznane procesy',
    unrecognizedProcesses: 'Nierozpoznane procesy',
    recognitionRate: 'Skuteczność rozpoznania',
    confidenceScore: 'Poziom pewności'
    ,
    hourUnit_one: 'godzina',
    hourUnit_few: 'godziny',
    hourUnit_many: 'godzin',
    notificationSettings: 'Ustawienia powiadomień',
    notificationSettingsAdmin: 'Ustawienia powiadomień użytkownika',
    notificationHistory: 'Historia powiadomień',
    notificationHistoryAdmin: 'Historia powiadomień',
    notificationsPerFilter: 'Powiadomienia',
    contactEmail: 'Adres e-mail',
    preferredLanguage: 'Język powiadomień',
    offlineThresholdMinutes: 'Próg braku komunikacji (min)',
    warningThresholdPercent: 'Próg ostrzegawczy (%)',
    notifyOffline: 'Alarm braku komunikacji',
    notifyReconnected: 'Przywrócenie komunikacji',
    notifyFilterWarning: 'Przygotuj się do wymiany',
    notifyFilterReplacement: 'Wymień filtr',
    notifyFilterReplacementReminder: 'Przypomnienie tygodniowe',
    recipient: 'Odbiorca',
    notificationType: 'Typ powiadomienia',
    notificationDetails: 'Szczegóły',
    adminConfirmNotificationEdit: 'Potwierdź edycję ustawień powiadomień użytkownika.',
    notificationType_offline: 'Brak komunikacji',
    notificationType_reconnected: 'Przywrócenie komunikacji',
    notificationType_filter_warning: 'Ostrzeżenie filtra',
    notificationType_filter_replacement: 'Wymiana filtra',
    notificationType_filter_replacement_reminder: 'Przypomnienie o wymianie',
    notificationType_filter_replacement_event: 'Nowy wpis wymiany',
    notificationType_device_malfunction: 'Awaria',
    notificationType_device_emergency: 'Anomalia',
    notificationStatus_pending: 'Oczekujące',
    notificationStatus_sent: 'Wysłane',
    notificationStatus_skipped: 'Pominięte',
    notificationStatus_failed: 'Błąd',
    notificationSettingsLoadError: 'Nie udało się wczytać ustawień powiadomień.',
    confirmAction: 'Potwierdź',
    close: 'Zamknij'

  },
  de: {
    login: 'Anmelden',
    username: 'Benutzername',
    password: 'Passwort',
    enterUsername: 'Geben Sie Ihren Benutzernamen ein',
    enterPassword: 'Geben Sie Ihr Passwort ein',
    invalidCredentials: 'Ungültige Anmeldedaten',
    dashboard: 'Dashboard',
    userInfo: 'Intelligenter Ölnebelfilter',
    welcomeUser: 'Willkommen, Benutzer!',
    devices: 'Geräte',
    language: 'Sprache',
    logout: 'Abmelden',
    loadingDevices: 'Geräte werden geladen...',
    loadingData: 'Daten werden geladen...',
    testText: 'Dies ist eine Testkachel.',
    cleaned: 'Gereinigt',
    dirty: 'Verschmutzt',
    filter_pressure: 'Filterdruck',
    filter_status: 'Filterstatus',
    no_proces: 'Kein Prozess',
    process_recognition: 'Prozesserkennung',
    process_unrecognized: 'Nicht erkannter Prozess',
    nonr_proces: 'Nicht erkannter Prozess',
    r_proces: 'Erkannter Prozess',
    cleaning: 'Reinigung',
    off: 'Deaktiviert',
    cleaning_pressure: 'Reinigungsdruck',
    filter_usage_history: 'Filtereinsatz-Verbrauch im Zeitverlauf',
    last: 'Letzter Datensatz',
    basicView: 'Basisansicht',
    advancedView: 'Erweiterte Ansicht',
    loading: 'Wird geladen...',
    minutes: 'Min',
    hours: 'Std',
    days: 'Tage',
    timeUnitInfo: 'Angezeigte Werte sind in Minuten, Stunden oder Tagen je nach Menge.',
    regression: 'Regression',
    threshold: 'Schwellenwert für den Filterwechsel',
    hepa_filter: 'Filtereinsatz-Verbrauch',
    process_times: 'Prozesszeiten',
    device_statistics: 'Gerätestatistiken',
    allTime: 'Gesamtlaufzeit des Geräts seit Filterwechsel',
    fanTime: 'Lüfterlaufzeit seit Filterwechsel',
    lastReadStatus: 'Zuletzt gelesener Status',
    unknown: 'Unbekannt',
    noCommunicationSince: 'Keine Kommunikation seit',
    hour: 'Stunde',
    day: 'Tag',
    no_proces_desc: 'Während dieses Zustands wird kein Prozess durchgeführt.',
    process_recognition_desc: 'Ein neuer Prozess wurde gestartet und wird gerade erkannt.',
    process_unrecognized_desc: 'Der Prozess wurde nicht erkannt.',
    nonr_proces_desc: 'Das Gerät befindet sich in der Prozesserkennung oder der Prozess wurde nicht erkannt.',
    r_proces_desc: 'Das Gerät hat den Prozess korrekt erkannt.',
    cleaning_desc: 'Das Gerät befindet sich im Reinigungsmodus der Arbeitskammer.',
    adminPanel: 'Admin-Bereich',
    adminOnly: 'Nur für Administratoren',
    createUser: 'Benutzer erstellen',
    assignFilter: 'Filter zuweisen',
    selectUser: 'Benutzer auswählen',
    selectFilter: 'Filter auswählen',
    customFilterName: 'Filtername für den Benutzer',
    userAssignments: 'Benutzerzuweisungen',
    filtersOverview: 'Filterübersicht',
    hepaUsagePercent: 'Filtereinsatz-Verbrauch',
    assignedUsers: 'Anzahl zugewiesener Benutzer',
    assignedFilters: 'Anzahl zugewiesener Filter',
    save: 'Speichern',
    saveError: 'Speichern fehlgeschlagen',
    rename: 'Umbenennen',
    renameFilter: 'Filter umbenennen',
    renameFilterPrompt: 'Neuen Filternamen eingeben',
    renameSuccess: 'Der Filtername wurde gespeichert',
    filterNameRequired: 'Der Filtername ist erforderlich',
    searchUsers: 'Benutzer suchen...',
    searchDevices: 'Geräte suchen...',
    searchAssignments: 'Zuweisungen suchen...',
    searchFilters: 'Nach Name oder MAC suchen...',
    minHepa: 'Min Verbrauch %',
    maxHepa: 'Max Verbrauch %',
    clearFilters: 'Filter löschen',
    noResults: 'Keine Ergebnisse',
    usersList: 'Benutzer',
    role: 'Rolle',
    status: 'Status',
    adminRole: 'Administrator',
    userRole: 'Benutzer',
    activeStatus: 'Aktiv',
    inactiveStatus: 'Inaktiv',
    lastLogin: 'Letzte Anmeldung',
    activateUser: 'Aktivieren',
    deactivateUser: 'Deaktivieren',
    activateUserConfirm: 'Dieses Benutzerkonto aktivieren?',
    deactivateUserConfirm: 'Dieses Benutzerkonto deaktivieren?',
    changePassword: 'Passwort ändern',
    newPasswordPrompt: 'Neues Passwort eingeben',
    confirmPasswordPrompt: 'Neues Passwort bestätigen',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    passwordChanged: 'Passwort wurde geändert',
    passwordRequired: 'Beide Passwortfelder sind erforderlich',
    kioskManagement: 'Kiosk-Verwaltung',
    kioskName: 'Kiosk-Name',
    kioskSlug: 'Kiosk-Slug',
    createKiosk: 'Kiosk erstellen',
    kiosksList: 'Kioske',
    generateActivationLink: 'Aktivierungslink erstellen',
    activationLinkGenerated: 'Aktivierungslink erstellt und in die Zwischenablage kopiert',
    latestActivationLink: 'Letzter Aktivierungslink',
    adminMainTab: 'Hauptbereich',
    adminUsersTab: 'Benutzer',
    adminFiltersTab: 'Filter',
    adminKioskTab: 'Kioske',
    searchKiosks: 'Kioske suchen...',
    edit: 'Bearbeiten',
    editKiosk: 'Kiosk bearbeiten',
    deactivateKiosk: 'Deaktivieren',
    activateKiosk: 'Aktivieren',
    allowedIp: 'Erlaubte IP (optional)',
    cancel: 'Abbrechen',
    kioskFilterName: 'Kiosk-Filtername',
    leaflet: 'Flyer',
    devicesAdmin: 'Geräteübersicht',
    serialNumber: 'Seriennummer',
    location: 'Standort',
    globalFilterNamePrompt: 'Globalen Filternamen eingeben',
    serialNumberPrompt: 'Seriennummer eingeben',
    locationPrompt: 'Standort eingeben',
    delete: 'Löschen',
    deleteConfirm: 'Möchtest du diesen Eintrag wirklich löschen?',
    hepaEvents: 'Wechselereignisse der Filtereinsaetze',
    addReplacementEvent: 'Wechsel hinzufügen',
    editReplacementEvent: 'Wechselereignis bearbeiten',
    replacementHour: 'Zeitpunkt des Wechsels',
    replacementHourPrompt: 'Datum/Uhrzeit des Wechsels eingeben (ISO)',
    completedProcesses: 'Abgeschlossene Prozesse',
    recognizedProcesses: 'Erkannte Prozesse',
    unrecognizedProcesses: 'Nicht erkannte Prozesse',
    recognitionRate: 'Erkennungsquote',
    confidenceScore: 'Sicherheitswert',
    hourUnit_one: 'Stunde',
    hourUnit_few: 'Stunden',
    hourUnit_many: 'Stunden',
    replacementNote: 'Notiz',
    replacementNotePrompt: 'Notiz eingeben',
    replacementHourRequired: 'Datum und Uhrzeit des Wechsels sind erforderlich',
    source: 'Quelle',
    daily_completed_processes: 'Heute abgeschlossene Prozesse',
    notificationSettings: 'Benachrichtigungseinstellungen',
    notificationSettingsAdmin: 'Benachrichtigungseinstellungen des Benutzers',
    notificationHistory: 'Benachrichtigungsverlauf',
    notificationHistoryAdmin: 'Benachrichtigungsverlauf',
    notificationsPerFilter: 'Benachrichtigungen',
    contactEmail: 'Kontakt-E-Mail',
    preferredLanguage: 'Benachrichtigungssprache',
    offlineThresholdMinutes: 'Schwelle ohne Kommunikation (Min)',
    warningThresholdPercent: 'Warnschwelle (%)',
    notifyOffline: 'Alarm bei fehlender Kommunikation',
    notifyReconnected: 'Kommunikation wiederhergestellt',
    notifyFilterWarning: 'Auf Wechsel vorbereiten',
    notifyFilterReplacement: 'Filter wechseln',
    notifyFilterReplacementReminder: 'Wöchentliche Erinnerung',
    recipient: 'Empfänger',
    notificationType: 'Benachrichtigungstyp',
    notificationDetails: 'Details',
    adminConfirmNotificationEdit: 'Änderung der Benachrichtigungseinstellungen des Benutzers bestätigen.',
    notificationType_offline: 'Keine Kommunikation',
    notificationType_reconnected: 'Kommunikation wiederhergestellt',
    notificationType_filter_warning: 'Filterwarnung',
    notificationType_filter_replacement: 'Filterwechsel',
    notificationType_filter_replacement_reminder: 'Wechsel-Erinnerung',
    notificationType_filter_replacement_event: 'Neuer Wechseleintrag',
    notificationType_device_malfunction: 'Fehler',
    notificationType_device_emergency: 'Anomalie',
    notificationStatus_pending: 'Ausstehend',
    notificationStatus_sent: 'Gesendet',
    notificationStatus_skipped: 'Übersprungen',
    notificationStatus_failed: 'Fehlgeschlagen',
    notificationSettingsLoadError: 'Benachrichtigungseinstellungen konnten nicht geladen werden.',
    confirmAction: 'Bestätigen',
    close: 'Schließen',
  },
};

export default translations;
